import { noop } from 'lodash';

import { Dialog } from '@lyearn/ui';
import Error403 from '@/components/Error/403';
import Loader from '@/components/Loader';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import { useAppConfig } from '@/hooks/useAppConfig';
import { DEFAULT_DIALOG_CONFIG } from '@/modules/corporate/components/ContentsDialog/utils';
import useContents from '@/modules/corporate/hooks/useContents';
import { EDITOR_MODAL_CLASSES } from '@/modules/corporate/modules/assignment/modals/AssignmentCreatorModal/styles';
import { ASSIGNMENT_RESTRICTION_DIALOG_CONFIG } from '@/modules/corporate/modules/assignment/views/AssignmentCreator/components/ContentAndCollectionList';
import {
  AssignmentRestrictionType,
  AssignmentRestrictionTypeEnum,
  ResourceStatusEnum,
} from '@/types/schema';

export const AssignmentRestrictionHandler: React.FC<
  React.PropsWithChildren<{
    assignmentRestriction?: AssignmentRestrictionType | null;
    contentId: string;
    onClose: () => void;
  }>
> = ({ children, contentId, assignmentRestriction, onClose }) => {
  const {
    site: { enableAssignmentRestriction },
  } = useAppConfig();

  const isRestricted =
    enableAssignmentRestriction &&
    assignmentRestriction?.type === AssignmentRestrictionTypeEnum.Restricted;

  const { contents, isFetching } = useContents({
    otherFilters: {
      status: [ResourceStatusEnum.Published, ResourceStatusEnum.UnpublishedChanges],
      intent: ASSIGNMENT_RESTRICTION_DIALOG_CONFIG?.contentQueryIntent,
      ids: [contentId],
    },
    types: DEFAULT_DIALOG_CONFIG['contentTypes'],
    pause: !isRestricted,
  });

  if (isFetching) {
    return (
      <Dialog open classes={EDITOR_MODAL_CLASSES} onClose={noop}>
        <Loader />
      </Dialog>
    );
  }

  if (!isRestricted) {
    return children;
  }

  if (isRestricted && contents[0]?.id === contentId) {
    return children;
  }

  return (
    <Modal open classes={EDITOR_MODAL_CLASSES} variant={ModalVariant.FullScreen} onClose={onClose}>
      <Error403 resource="content" />
    </Modal>
  );
};

export default AssignmentRestrictionHandler;
